import { createAction, props } from '@ngrx/store';
import { UserAppResponse } from '../services/models/app-user.model';
import { ApplicationDetailsResponse } from '../services/models/application-details.model';

//Currently selected application
export const setSelectedApplication = createAction(
  '[App] Set Selected Application',
  props<{ applicationId: number }>()
);

export interface CurrentUser {
  email: string;
  name: string;
}

export const setCurrentUser = createAction(
  '[App] Set Current User',
  props<{ user: CurrentUser }>()
);


//Selected application details
export const setSelectedAppDetails = createAction(
  '[App] Set Selected Application Details',
  props<{ selectedAppDetails: ApplicationDetailsResponse }>()
);

//App List
export const setAppList = createAction(
  '[App] Set App List',
  props<{ appList: UserAppResponse[] }>()
);
